import axios from "axios";

/* const getHost=(host)=>{
    const hostname = window.location.hostname
    if(hostname.includes('http://localhost:3000/')){
        return 'http://localhost:8080/'
    } 
} */

const local = 'http://localhost:3002'
const host = 'https://backendfunemg-backfune.alehbv.easypanel.host'

export const currentServer = host

export const ApiLoginUser = async (params) =>
    axios.post(`${currentServer}/api/login`, params)

export const getInfoAlunoByCpf = async ({ cpf: cpf }) =>
    axios.get(`${currentServer}/api/getUserByCPF/${cpf}`)

export const registarAcessoValidarCertificado = async ({ idUser, tipo }) =>
    axios.post(`${currentServer}/api/registarAcessoValidarCertificado`, { idUser, tipo })


export const getAllCursos = async (params) =>
    axios.get(`${currentServer}/api/cursos`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const verifyEmailExist = async ({ userEmail }) =>
    axios.post(`${currentServer}/api/verifyEmailExist`, { userEmail }, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const getAllCursosEstudante = async ({ id }) =>
    axios.post(`${currentServer}/api/cursosMatriculados`, { id }, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const MatricularCurso = async ({ userId, cursoId }) =>
    axios.post(`${currentServer}/api/matricular`, { userId, cursoId },)

export const desmatricularCurso = async ({ userId, cursoId }) =>
    axios.post(`${currentServer}/api/desmatricular`, { userId, cursoId },)


export const concluirAula = async ({ aulaId, userId }) =>
    axios.post(`${currentServer}/api/concluirAula`, { userId, aulaId },)


export const CadastrarFuncionarioApi = async (params) =>
    axios.post(`${currentServer}/api/addFuncionario`, params,)

export const CadastrarUser = async (params) =>
    axios.post(`${currentServer}/api/addEstudante`, params,)

export const getAlunoByPageSize = async ({ size, page }) =>
    axios.post(`${currentServer}/api/getUserBySize`, { size, page },)

export const getImagemByUserId = async ({ id }) =>
    axios.get(`${currentServer}/api/imagem/${id}`)


export const shortenLink = (link) => axios.get(`https://tinyurl.com/api-create.php?url=${link}`);

export const getFuncionarios = async () =>
    axios.get(`${currentServer}/api/getFuncionarios`)

export const getInfoAluno = async ({ email: userEmail }) =>
    axios.get(`${currentServer}/api/getUserByEmail/${userEmail}`)

export const editUserById = async (params) =>
    axios.put(`${currentServer}/api/updateEstudante`, params, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })
export const updateCpfByEmail = async ({cpf, email}) =>
    axios.put(`${currentServer}/api/updateCpfByEmail`, {cpf, email})


export const excluirUserByEmail = async ({ email }) =>
    axios.delete(`${currentServer}/api/deleteEstudante/${email}`)


// OLD CODE
export const LoginUser = async (params) =>
    axios.post(`${currentServer}/usuario/login`, params,)



export const CadastrarEstudante = async (params) =>
    axios.post(`${currentServer}/estudante/cadastro`, params,)


export const getInfoAluno1 = async ({ email }) =>
    axios.get(`${currentServer}/aluno/validacao/${email}`)







export const excluirUserById1 = async (id) =>
    axios.delete(`${currentServer}/estudante/delete/${id}`, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })

export const editUserById1 = async (params) =>
    axios.put(`${currentServer}/estudante/editar`, params, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem("token")}`
        }
    })






